import { useState } from "react";
import {
  Container,
  Card,
  Typography,
  Box,
  TextField,
  Button,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableRow
} from "@mui/material";

import { getOtp, updateOtp } from "../api/users";

export default function ManageOtp() {

  const [phone, setPhone] = useState("");

  const [businessOtp, setBusinessOtp] = useState("");
  const [userOtp, setUserOtp] = useState("");
  const [virtualOtp, setVirtualOtp] = useState("");

  const [userFound, setUserFound] = useState(false);
  const [showVirtual, setShowVirtual] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const showSnackbar = (msg, type = "success") => {
    setSnackbarMsg(msg);
    setSnackbarType(type);
    setOpenSnackbar(true);
  };

  const resetState = () => {
    setBusinessOtp("");
    setUserOtp("");
    setVirtualOtp("");
    setUserFound(false);
    setShowVirtual(false);
  };

  const handleSearch = async () => {

    if (!/^\d{10}$/.test(phone)) {
      return showSnackbar("Enter valid 10 digit phone number", "warning");
    }

    resetState();

    try {

      const res = await getOtp({
        phoneNumber: `+91${phone}`
      });

      const data = res?.data || {};

      setBusinessOtp(data.businessOtp || "");
      setUserOtp(data.userOtp || "");
      setVirtualOtp(data.virtualOtp || "");

      setShowVirtual(data.showVirtual || false);
      setUserFound(true);

      showSnackbar("OTP data loaded", "success");

    } catch (err) {
      showSnackbar("User not found", "warning");
    }
  };

  const isValidOtp = (otp) => /^\d{6}$/.test(otp);

  const handleSave = async () => {

    if (
      (businessOtp && !isValidOtp(businessOtp)) ||
      (userOtp && !isValidOtp(userOtp)) ||
      (virtualOtp && !isValidOtp(virtualOtp))
    ) {
      return showSnackbar("OTP must be exactly 6 digits", "warning");
    }

    try {

      const payload = {
        phoneNumber: `+91${phone}`,
        businessUserOtp: businessOtp,
        userOtp: userOtp,
        virtualNumberOtp: virtualOtp
      };

      await updateOtp(payload);

      showSnackbar("OTP Updated Successfully", "success");

    } catch (err) {
      showSnackbar("Failed to update OTP", "error");
    }
  };

  return (
    <Container sx={{ mt: 3, maxWidth: 700 }}>

      <Typography variant="h4" mb={3}>
        Manage OTP
      </Typography>

      <Card sx={{ p: 4 }}>

        <Box sx={{ display: "flex", gap: 2, mb: 3 }}>

          <TextField
            label="Phone Number"
            value={phone}
            onChange={(e) => {
              const val = e.target.value.replace(/\D/g, "");
              if (val.length <= 10) setPhone(val);
            }}
            fullWidth
          />

          <Button
            variant="contained"
            onClick={handleSearch}
          >
            Search
          </Button>

        </Box>

        {userFound && (

          <>
            <Table>

              <TableBody>

                {businessOtp !== "" && (
                  <TableRow>

                    <TableCell>
                      <b>Business User OTP</b>
                    </TableCell>

                    <TableCell>
                      <TextField
                        value={businessOtp}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "");
                          if (val.length <= 6) setBusinessOtp(val);
                        }}
                        size="small"
                      />
                    </TableCell>

                  </TableRow>
                )}

                <TableRow>

                  <TableCell>
                    <b>User OTP</b>
                  </TableCell>

                  <TableCell>
                    <TextField
                      value={userOtp}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        if (val.length <= 6) setUserOtp(val);
                      }}
                      size="small"
                    />
                  </TableCell>

                </TableRow>

                {showVirtual && (

                  <TableRow>

                    <TableCell>
                      <b>Virtual Number OTP</b>
                    </TableCell>

                    <TableCell>
                      <TextField
                        value={virtualOtp}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "");
                          if (val.length <= 6) setVirtualOtp(val);
                        }}
                        size="small"
                      />
                    </TableCell>

                  </TableRow>

                )}

              </TableBody>

            </Table>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 3
              }}
            >

              <Button
                variant="contained"
                onClick={handleSave}
              >
                Save
              </Button>

            </Box>

          </>
        )}

      </Card>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbarType} sx={{ width: "100%" }}>
          {snackbarMsg}
        </Alert>
      </Snackbar>

    </Container>
  );
}